<template>
<div>
  <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
  <div v-if="sub_tasklists_lists.length > 0">
    <hr>
    <div class="font-25" style="color: #4c94cf">Sub Tasklists:</div>
      <div class="col-12 override-padding" >
        <ul v-sortable="{onEnd: reorderSubTask, handle: '.handle'}" class="counter_subtask-list col-lg-12">
          <li class="col-12 input-height-25" v-for="(sub_tasklists_list, index) in sub_tasklists_lists" :key="sub_tasklists_list.sortid">
            <div class="handle float-left col-lg-10 col-md-8 col-6">
              <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
              <span class="counter_subtask-list__counter"></span>
              {{ sub_tasklists_list.name }}
              <span style="color: #007BFF;">(Tasks: {{ sub_tasklists_list.tasks_count }})</span>
            </div>
            <div class="float-right font-15 col-lg-1 col-md-2 col-3">
              <button
                v-on:click="deleteSubTask(sub_tasklists_list.id)"
                class="btn btn-action edit-action-btn input-height-25"
                >Remove</button>
            </div>
            <div class="float-right font-15 col-lg-1 col-md-2 col-3">
              <button
                v-on:click="linkToAddTask(sub_tasklists_list.id)"
                class="btn btn-action edit-action-btn input-height-25"
                >Edit</button>
            </div>
            <div style="clear: both"></div>
          </li>
        </ul>
        <div style="clear: both" class="margin-bottom-15"></div>
      </div>
  </div>
</div>

</template>

<script>

import Vue from 'vue/dist/vue.esm';
import Sortable from 'sortablejs';

Vue.directive('sortable', {
  inserted: function (el, binding) {
    var sortable = new Sortable(el, binding.value || {});
  }
});

  export default {
    props: ['sub_tasklists_lists', 'loading'],
    methods: {
      deleteSubTask(sub_tasklist_id) {
        this.$parent.deleteSubTaskListConfirm(sub_tasklist_id)
      },
      linkToAddTask: function(sub_tasklist_id) {
        this.$parent.linkToAddTaskAction(sub_tasklist_id)
      },
      reorderSubTask ({oldIndex, newIndex}) {
        this.$parent.reorderSubTaskAction(oldIndex, newIndex);
      },
    },
  }
</script>

<style scoped>
.container-wrapper ul {
  list-style: none;
  padding: 0px;
}
.container-wrapper ul li {
  padding: 5px 5px;
  border: 1px solid #CCC;
  margin-top: 10px;
  float: left;
  margin-left: 0px;
}
.btn {
  padding: 1px 0px;
}
.edit-action-btn {
  width: 65px;
  margin-right: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/admin/subtask_list.vue